import { Link } from 'react-router-dom';

import classNames from 'classnames';

import styles from './_index.module.scss';

export interface IconCTAProps {
  className?: string;
  'data-testid'?: string;
  href?: string;
  icon: React.ReactNode;
  onClick?: () => void;
  path?: string;
  state?: Record<string, unknown>;
  text?: string;
}

const IconCTA = ({
  className,
  'data-testid': dataTestId = 'icon-cta',
  href,
  icon,
  onClick = () => {},
  path,
  state,
  text,
  ...props
}: IconCTAProps) => {
  let iconCta = null;
  const iconCtaClasses = classNames(styles['icon-cta'], className);

  if (href) {
    iconCta = (
      <a className={iconCtaClasses} data-testid={dataTestId} href={href} {...props}>
        <span>{icon}</span>
        {text && <span>{text}</span>}
      </a>
    );
  } else if (path) {
    iconCta = (
      <Link className={iconCtaClasses} data-testid={dataTestId} state={state} to={path} {...props}>
        <span>{icon}</span>
        {text && <span>{text}</span>}
      </Link>
    );
  } else if (onClick) {
    iconCta = (
      <button className={iconCtaClasses} data-testid={dataTestId} onClick={onClick} {...props}>
        <span>{icon}</span>
        {text && <span>{text}</span>}
      </button>
    );
  }

  return iconCta;
};

export default IconCTA;
